// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_IjXyZ","secondaryColumnCell":"secondary-column-cell_IjXyZ","name":"name_fCRiG"};